module.exports = __webpack_public_path__ + "9baec0ab0bc3096fb9fe865d6ae29d1d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-20.woff
// module id = 2465
// module chunks = 0